import { constantRoutes } from '@/router'
import { getRoleMenusPermissions } from '@/api/menu'
import Layout from '@/layout'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * 处理视图
 * @param view
 * @returns {any}
 */
export const loadView = (view) => { // 路由懒加载
  if (view === 'Layout') {
    return Layout
  } else {
    // console.log('---------------------------',view);
    // console.log(`@/views/${view}`);
    return (resolve) => require([`@/views/${view}`], resolve)
  }
}

/**
 * 处理路径
 * @param path
 * @returns {string|*}
 */
export const loadPath = (path) => { // 路由懒加载
  if (path.indexOf('/') === 0) {
    return path
  }
  return '/' + path
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    // 处理路径
    tmp.path = loadPath(tmp.path)
    // 处理组件
    tmp.component = loadView(tmp.component)
    if (hasPermission(roles, tmp)) {
      console.log(tmp)
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
  permissions: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
    // console.log("...",state.routes);
  },
  // 设置指令权限
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      getRoleMenusPermissions().then(res => {
        console.log(res)
        const accessedRoutes = filterAsyncRoutes(res.data.menus, roles)
        console.log(accessedRoutes)
        commit('SET_ROUTES', accessedRoutes)
        // 设置指令权限
        commit('SET_PERMISSIONS', res.data.permissions)
        resolve(accessedRoutes)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
